export function coloredTabs() {
  const tabNavItem = $(".colored-tab-nav").find(".colored-tab");
  const tabContent = $(".colored-tab-content");

  tabNavItem.on("click", function (event) {
    event.preventDefault();
    let $this = $(this);
    let $href = $this.find("a").attr("href");
    $this.addClass("current-tab").siblings().removeClass("current-tab");
    $($href).addClass("current-tab").siblings().removeClass("current-tab");
  });
}


// WEBPACK FOOTER //
// ./assets/js/modules/coloredTabs.js